module.exports = __webpack_public_path__ + "static/media/atu.006444c8.png";